/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Rest_MinusInputs */

const en_us2_workout_rest_minus = /** @type {(inputs: Workout_Rest_MinusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`−15 s`)
};

const pt_br2_workout_rest_minus = /** @type {(inputs: Workout_Rest_MinusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`−15 s`)
};

const es_419_workout_rest_minus = /** @type {(inputs: Workout_Rest_MinusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`−15 s`)
};

const pt_pt2_workout_rest_minus = /** @type {(inputs: Workout_Rest_MinusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`−15 s`)
};

const fr_fr2_workout_rest_minus = /** @type {(inputs: Workout_Rest_MinusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`−15 s`)
};

const de_de2_workout_rest_minus = /** @type {(inputs: Workout_Rest_MinusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`−15 s`)
};

const it_it2_workout_rest_minus = /** @type {(inputs: Workout_Rest_MinusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`−15 s`)
};

/**
* | output |
* | --- |
* | "−15 s" |
*
* @param {Workout_Rest_MinusInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_rest_minus = /** @type {((inputs?: Workout_Rest_MinusInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Rest_MinusInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_rest_minus(inputs)
	if (locale === "es-419") return es_419_workout_rest_minus(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_rest_minus(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_rest_minus(inputs)
	if (locale === "de-DE") return de_de2_workout_rest_minus(inputs)
	if (locale === "it-IT") return it_it2_workout_rest_minus(inputs)
	return en_us2_workout_rest_minus(inputs)
});
export { workout_rest_minus as "workout.rest_minus" }